import React from 'react';
import styled from 'styled-components';
import flexbox from 'styles/utils/flexbox';
import { mediaQueries } from 'styles/utils/mediaQueries';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function SummarySectionComponent({ collapsed, title, children, onClickCollapse, airlineWhitelabel }) {
  return (
    <Root>
      <Header onClick={onClickCollapse}>
        <Title airlineWhitelabel={airlineWhitelabel}>{title}</Title>
        <CollapseButton collapsed={collapsed}>
          <FontAwesomeIcon icon='chevron-down' className='collapseIcon' />
        </CollapseButton>
      </Header>
      <Content collapsed={collapsed}>{children}</Content>
    </Root>
  );
}

export default SummarySectionComponent;

const Root = styled.div`
  background: ${({ theme }) => theme.colors.background.light};
`;

const Header = styled.div`
  ${flexbox({
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  })}

  padding: 20px;
  cursor: pointer;
`;

const Title = styled.h1`
  font-size: 1.8em;
  font-weight: ${({ airlineWhitelabel }) => (airlineWhitelabel && airlineWhitelabel.isAirBaltic ? 500 : 700)};
  color: ${({ theme }) => theme.colors.text.default};

  ${mediaQueries.fromAndAbove.desktop`
    font-size: 1.6em;
  `}
`;

const CollapseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  .collapseIcon {
    -webkit-transition: all 0.3s ease-in;
    transition: all 0.3s ease-in;
    transform: ${({ collapsed }) => !collapsed && `rotate(180deg)`};
  }
`;

const Content = styled.div`
  max-height: ${({ collapsed }) => (collapsed ? '0px' : '500px')};
  padding: 0 20px;
  overflow: hidden;
  transition: max-height 0.3s ease-in;
`;
